import type { PropsWithChildren } from "react";
import type { Props } from "./DataImportChangesListActionsContext";
import { DataImportChangesListActionsContext } from "./DataImportChangesListActionsContext";

export const DataImportChangesListActionsContextProvider = ({
  children,
  ...contextValue
}: PropsWithChildren<Props>) => (
  <DataImportChangesListActionsContext value={contextValue}>{children}</DataImportChangesListActionsContext>
);
